




import {
  CarpsaleManagementCarpsaleService,
  CarpsaleManagementListItemRequest,
} from "@/common/api";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import LiveItemPdfComponent from "@/components/admin/live/common/liveItemPdfComponent.vue";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "ExportItemsComponent",
  components: {
    QCalendar,
    QInputMultipleLanguage,
    LiveItemPdfComponent,
    QErrors,
  },
})
export default class ExportItemsComponent extends Vue {
  public name: "ExportItemsComponent";
  public errors = {};
  @Prop({
    default: () => {
      return {};
    },
  })
  public filter: CarpsaleManagementListItemRequest;

  @Prop({
    type: Number,
    default: () => {
      return 0;
    },
  })
  public total;

  public async exportCsv() {
    this.errors = {};
    let result;

    try {
      result = await CarpsaleManagementCarpsaleService.adminCarpsaleExport(
        this.filter,
      );

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });

        /* eslint-disable unicorn/number-literal-case */
        const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
        const blob = new Blob([bom, result.data.csv], { type: "text/csv" });
        const anchor = document.createElement("a");
        anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
        anchor.target = "_blank";
        anchor.download =
          "錦鯉販売管理（carpsale）" +
          moment().format("_YYYYMMDD_HHmmss") +
          ".csv";
        anchor.click();
        anchor.remove();
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.errors = result.body.errors;
      }
    }
  }
}
